var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26879",
    "data-name": "Group 26879",
    transform: "translate(-536.493 -398.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26870",
    "data-name": "Group 26870",
    transform: "translate(-1006.57 -842.578)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1536",
    "data-name": "Ellipse 1536",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1543.063 1241.486)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.993 221.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M26.44,326.657a.95.95,0,0,0,.631-.226l-3.057-2.9-.212.145q-.343.24-.557.375a3.5,3.5,0,0,1-.569.275,1.811,1.811,0,0,1-.662.14H22a1.81,1.81,0,0,1-.662-.14,3.489,3.489,0,0,1-.569-.275q-.214-.134-.557-.375L20,323.525l-3.057,2.906a.95.95,0,0,0,.631.226Z",
    transform: "translate(-16.631 -318.206)",
    fill: "#424e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M.578,199.053a3.034,3.034,0,0,1-.578-.5v4.42l2.56-2.56Q1.792,199.878.578,199.053Z",
    transform: "translate(0 -195.562)",
    fill: "#424e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M415.3,199.053q-1.169.791-1.987,1.363l2.559,2.559v-4.42A3.158,3.158,0,0,1,415.3,199.053Z",
    transform: "translate(-405.112 -195.562)",
    fill: "#424e55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M9.8,59.013H.966a.876.876,0,0,0-.711.3,1.119,1.119,0,0,0-.249.744,1.3,1.3,0,0,0,.33.781,2.916,2.916,0,0,0,.7.661q.2.137,1.23.815l.967.64.606.4.09.061.166.114q.2.134.324.217t.312.186a1.864,1.864,0,0,0,.345.154,1,1,0,0,0,.3.051H5.39a1,1,0,0,0,.3-.051,1.859,1.859,0,0,0,.345-.154q.183-.1.312-.186t.324-.217l.165-.114.09-.061.607-.4,2.2-1.457a2.79,2.79,0,0,0,.732-.7,1.466,1.466,0,0,0,.294-.864.858.858,0,0,0-.285-.647A.952.952,0,0,0,9.8,59.013Z",
    transform: "translate(-0.006 -59.013)",
    fill: "#424e55"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeCircle);
export default __webpack_public_path__ + "static/media/envelope_circle.166c0fc375e241394c80166b2d89d062.svg";
export { ForwardRef as ReactComponent };